import { useMemo } from "react";
import { useIntl } from "react-intl";
import { object, string } from "yup";
import { EXEMPTION_TYPE, OVER_70, UNDER_5 } from "./formConstants";

export const useValidationSchema = () => {
  const { formatMessage } = useIntl();
  return useMemo(
    () =>
      object({
        [EXEMPTION_TYPE]: string()
          .oneOf([UNDER_5, OVER_70])
          .required(
            formatMessage({
              id: "invoices.exempt.validation.required",
              defaultMessage: "This is a required field",
            }),
          ),
      }),
    [formatMessage],
  );
};
